// @flow
export const GAME_PAGE_ROUTE = '/games/:gameId';
